import { useEffect, useMemo, useState } from "react";
import { RadioGroup } from "@headlessui/react";
import { mdiCheckCircleOutline, mdiCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

import Header from "components/Header";
import { THEMES } from "constants/user-settings";
import { useColorScheme } from "hooks/useColorScheme";
import MainLayout from "layouts/Main";
import styles from "./style.module.scss";

type Theme = "dark" | "light" | "auto";

export default function Theme() {
  const { isDark, setIsDark } = useColorScheme();
  const currentTheme = useMemo(() => {
    if (isDark === undefined) {
      return "auto";
    } else if (isDark) {
      return "dark";
    } else {
      return "light";
    }
  }, [isDark]);

  const [theme, setTheme] = useState<Theme>(currentTheme);

  useEffect(() => {
    if (theme === "auto") {
      setIsDark(undefined);
    } else {
      setIsDark(theme === "dark");
    }
  }, [theme]);

  return (
    <MainLayout
      desktopTitle="Theme"
      customHeader={<Header label="Theme" headerIcon=" " isHideDesktop />}
      hideNavigation
      className="pb-12">
      <RadioGroup value={theme} onChange={setTheme}>
        <div className={styles.themeContainer}>
          {THEMES.map((item) => (
            <RadioGroup.Option
              key={item.id}
              value={item.value}
              className={clsx(
                styles.optionItem,
                item.id === 2 ? "col-start-2 col-span-2" : "col-span-2"
              )}>
              {({ checked }) => (
                <div className={styles.itemWrapper}>
                  <item.phoneTheme className="flex-none w-full" />
                  <div className={styles.checkbox}>
                    {checked ? (
                      <Icon path={mdiCheckCircleOutline} className="size-6 text-success" />
                    ) : (
                      <Icon path={mdiCircleOutline} className="size-6 text-background" />
                    )}
                    <span className={checked ? "text-success" : "text-background"}>
                      {item.subtitle}
                    </span>
                  </div>
                </div>
              )}
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
    </MainLayout>
  );
}
